import type { Command } from '../../types/commands'
import { resolvePath, isValidDirectory, toDisplayPath } from '../pathUtils'
import { findSessionNode } from '../sessionFilesystem'
import { getContextDefaults } from '../../utils/contextUtils'

export const cdCommand: Command = {
  name: 'cd',
  description: 'Change directory/section',
  usage: 'cd [directory]',
  category: 'navigation',
  acceptsFiles: false,
  acceptsDirectories: true,
  execute: (args, context) => {
    const { currentDirectory, sessionFs } = getContextDefaults(context)

    // If no args, go to home directory
    if (args.length === 0) {
      context?.setCurrentDirectory('~')
      return [
        {
          type: 'info',
          content: 'Changed to home directory\n\nType "ls" to see contents',
        },
      ]
    }

    // Resolve the target path (handles absolute, relative, parent, etc.)
    const targetPath = args[0]
    const resolvedPath = resolvePath(targetPath, currentDirectory)

    // Check if directory exists in static filesystem OR session filesystem
    const sessionNode = findSessionNode(sessionFs, resolvedPath)
    const isSessionDirectory = sessionNode?.type === 'directory'
    const isStaticDirectory = isValidDirectory(resolvedPath)

    if (!isStaticDirectory && !isSessionDirectory) {
      return [
        {
          type: 'error',
          content: `cd: ${targetPath}: No such directory`,
        },
      ]
    }

    // Update current directory (use display format for consistency)
    const displayPath = toDisplayPath(resolvedPath)
    context?.setCurrentDirectory(displayPath)

    // Generate success message
    return [
      {
        type: 'info',
        content: `Changed to ${displayPath}\n\nType "ls" to see contents`,
      },
    ]
  },
}
